import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { AnswerOptions } from "../models/answer-options.model";

@Injectable({
  providedIn: "root",
})
export class AnswerOptionsService {
  constructor(private http: HttpClient) {}

  /** All answer options across every question in a quiz, for taking the quiz in one call. */
  async findByQuiz(courseId: number, chapterId: number, quizId: number): Promise<AnswerOptions[]> {
    return this.http
      .get<AnswerOptions[]>(
        `${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/answeroptions`
      )
      .toPromise();
  }

  async findByQuestion(courseId: number, chapterId: number, quizId: number, questionId: number): Promise<AnswerOptions[]> {
    return this.http
      .get<AnswerOptions[]>(
        `${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions/${questionId}/answeroptions`
      )
      .toPromise();
  }

  findById(courseId: number, chapterId: number, quizId: number, questionId: number, answerOptId: number): Promise<AnswerOptions> {
    return this.http
      .get<AnswerOptions>(
        `${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions/${questionId}/answeroptions/${answerOptId}`
      )
      .toPromise();
  }

  create(courseId: number, chapterId: number, quizId: number, questionId: number, answerOptions: AnswerOptions): Promise<AnswerOptions> {
    return this.http
      .post<AnswerOptions>(
        `${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions/${questionId}/answeroptions`,
        answerOptions
      )
      .toPromise();
  }

  update(courseId: number, chapterId: number, quizId: number, questionId: number, answerOptId: number, answerOptions: AnswerOptions) {
    return this.http
      .put(
        `${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions/${questionId}/answeroptions/${answerOptId}`,
        answerOptions
      )
      .toPromise();
  }

  delete(courseId: number, chapterId: number, quizId: number, questionId: number, answerOptId: number) {
    return this.http
      .delete(
        `${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions/${questionId}/answeroptions/${answerOptId}`
      )
      .toPromise();
  }
}
